import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

const useGetPage = (id: number) => {
	const activeReducerPage: IPageViewModel | null = useSelector(
		(state: { pageReducer: { pages: { [key: number]: IPageViewModel } } }) => state.pageReducer.pages[id] || null
	);
	const [page, setPage]: [IPageViewModel | null, any] = useState(activeReducerPage);

	useEffect(() => {
		if (page === null && activeReducerPage) setPage(activeReducerPage);
	}, [id, activeReducerPage, page]);

	return page;
};

export default useGetPage;
